import { Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-private-class-banner-container',
  template: `
    <div
      [ngClass]="
        (reducedBannerWidth ? 'reducedBannerWidth' : 'w-100') +
        ' position-relative d-flex align-items-center my-5 my-xl-0 mb-xl-5'
      "
    >
      <div
        [ngClass]="
          (reducedBannerWidth ? '' : 'min-height-400') +
          ' banner position-relative d-flex flex-1 flex-column justify-content-center justify-content-xl-start align-items-center align-items-xl-start'
        "
      >
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./private-class-banner-container.component.scss'],
})
export class PrivateClassBannerContainerComponent {
  @Input() reducedBannerWidth: boolean;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-banner-container/private-class-banner-container.component.ts